import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-area-pix',
  templateUrl: './area-pix.component.html',
  styleUrls: ['./area-pix.component.css']
})
export class AreaPixComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
